module.exports = __webpack_public_path__ + "media/img/carq-powypadkowe-dea02bc8.png";